import { DEFAULT_DELAY, DEFAULT_MAX_DELAY } from './constants'

/**
 * Calculate retry delay using exponential backoff with randomization
 * @param retryCount Current retry attempt count
 * @returns Delay in milliseconds
 */
const calculateRetryDelay = (retryCount: number): number => {
  const randomizedDelay = DEFAULT_DELAY * (0.5 * Math.random())
  const delay = Math.min(
    randomizedDelay * Math.pow(retryCount + 1, 2),
    DEFAULT_MAX_DELAY,
  )
  return delay
}

export default calculateRetryDelay
